

import React, { Component, useState } from 'react';
import TopFilterData from './TopFilterData';
import AddFilter from '../images/filter.png';
import { Dropdown, Spinner } from "react-bootstrap";
import GridHeaderfilter from './GridHeaderfilter';
import configData from '../configData.json';
import { useRef } from 'react';
import { addDays, getDate, set } from 'date-fns';
import { useEffect } from 'react';
// import DatePicker from "react-datepicker";

// import "react-datepicker/dist/react-datepicker.css";
import DatePicker from 'react-date-picker';
import moment from 'moment';
import SelectSearch, { fuzzySearch } from 'react-select-search';

export default function TopFilter({ oncustom, isAddFilterHidden, criData, isDateDropdownHidden }) {
    // debugger; 
    const [toDate, setToDate] = useState(new Date());
    const [fromDate, setFromDate] = useState(new Date(toDate.getFullYear(), 0, 1, 23, 59, 59));
    const defaultFromValue = fromDate.toISOString().substring(0, 10);
    const defaultToValue = toDate.toISOString().substring(0, 10);
    const [selectedFromDate, setSelectedFromDate] = useState(moment(fromDate).format().substring(0, 10));
    const [selectedToDate, setSelectedToDate] = useState(moment(toDate).format().substring(0, 10));

    const [filterKey, setFilterKey] = useState('');
    const [inputFields, setInputFields] = useState([]);
    const [carriers, setCarriers] = useState([]);
    const [divsions, setDivisions] = useState([]);
    const [selectedOwner, setSelectedOwner] = useState(0);
    const [selectedCust, setSelectedCust] = useState(0);
    const [selectedCarrier, setSelectedCarr] = useState(0);
    const [selectedDivision, setSelectedDivision] = useState(-1);

    const [selectedPastNumOfWeek, setSelectedPastNumOfWeek] = useState(20);
    const [selectedImmediatePastNumWeek, setSelectedImmediatePastNumWeek] = useState(3);
    const [selectedPercentageDecrease, setSelectedPercentageDecrease] = useState(20);
    const [selectedPercentageIncrease, setSelectedPercentageIncrease] = useState(20);

    const [fbNum, setFbNum] = useState("-1");
    const [acctNo, setAcctNo] = useState("-1");

    const [show, setShow] = useState(false);

    const [ownerLoading, isOwnerLoading] = useState(false);
    const [customerLoading, isCustomerLoading] = useState(false);


    let selectedCustRef = useRef(0);
    selectedCustRef.current = selectedCust;

    const [owners, setOwners] = useState([]);
    const [customers, setCustomers] = useState([]);

    function upsert(array, element) { // (1)
        debugger;
        const i = array.findIndex(_element => _element.name === element.name);
        if (i > -1) {
            setInputFields(existingItems => {
                return existingItems.map((item, j) => {
                    // debugger;
                    return j === i ? element : item
                })
            })
            //array[i] = element; // (2)
        }
        else setInputFields([...inputFields, element]);
    }

    const LoadOwner = async () => {
        debugger;
        isOwnerLoading(true);
        const ownerUrl = `${configData.BASE_APP_URL}Owner/GetOwnerList`;
        await fetch(ownerUrl,
            {
                method: 'GET',
                headers: {
                    'Content-type': 'application/json',
                    'Authorization': sessionStorage.getItem('my-token')
                }
            }
        ).then(resp => resp.json())
            .then(resp => {
                let ownerOptions = [];
                resp.map(owner => {
                    const cust = {
                        "name": owner.ownerName,
                        "value": owner.ownerID
                    }
                    ownerOptions = [...ownerOptions, cust];
                })
                const defaultOwner = {
                    "name": "--All Owners--",
                    "value": 0
                }
                ownerOptions.unshift(defaultOwner);
                setOwners(ownerOptions)
            })
        isOwnerLoading(false);
        LoadCustomerDashboard(0);
        // setIsDisabled(props.isDisabled);
    }

    const onOwnerSelect = (e) => {
        debugger;
        var ownerkey = e;
        // if (ownerkey > 0) {
        //     document.getElementById("owner-error").innerHTML = "";
        //     document.getElementById("owner-highlight").innerHTML = "";
        // }
        setSelectedOwner(e);
        setSelectedCust(0);
        LoadCustomerDashboard(e);
        // props.onCustomerChange(custkey);


        oncustom(e, 0, selectedCarrier, selectedFromDate, selectedToDate, fbNum, acctNo);



    };

    const LoadCustomerDashboard = async (ownerKey) => {
        debugger;
        isCustomerLoading(true);
        const custUrl = `${configData.BASE_APP_URL}Customer/GetCustomerList/${ownerKey}`;
        await fetch(custUrl,
            {
                method: 'GET',
                headers: {
                    'Content-type': 'application/json',
                    'Authorization': sessionStorage.getItem('my-token')
                }
            }
        ).then(resp => resp.json())
            .then(resp => {
                let customerOptions = [];
                resp.map(customer => {
                    const cust = {
                        "name": customer.customerName,
                        "value": customer.customerKey
                    }
                    customerOptions = [...customerOptions, cust];
                })
                const defaultCustomer = {
                    "name": "--All Customers--",
                    "value": 0
                }
                customerOptions.unshift(defaultCustomer);
                setCustomers(customerOptions)
            })
        isCustomerLoading(false);
        // setIsDisabled(props.isDisabled);
    }

    const LoadCustomer = async (ownerKey) => {
        const URL = `${configData.BASE_APP_URL}Customer/GetCustomerList/${ownerKey}`;
        await fetch(URL,
            {
                method: 'GET',
                headers: {
                    'Content-type': 'application/json',
                    'Authorization': sessionStorage.getItem('my-token')
                }
            })
            .then(resp => resp.json())
            .then(resp => setCustomers(resp))
    }

    const LoadCarrier = async (customerKey) => {
        // isCarrierLoading(true);
        // setSelectedCust(customerKey);
        const URL = `${configData.BASE_APP_URL}Carrier/GetCarrierList/${customerKey}`;
        await fetch(URL,
            {
                method: 'GET',
                headers: {
                    'Content-type': 'application/json',
                    'Authorization': sessionStorage.getItem('my-token')
                }
            })
            .then(resp => resp.json())
            .then(resp => setCarriers(resp))
        // isCarrierLoading(false);
    }

    const LoadDivision = async (customerKey) => {
        // isCarrierLoading(true);
        // setSelectedCust(customerKey);
        const URL = `${configData.BASE_APP_URL}Division/GetDivisionList/${customerKey}`;
        await fetch(URL,
            {
                method: 'GET',
                headers: {
                    'Content-type': 'application/json',
                    'Authorization': sessionStorage.getItem('my-token')
                }
            })
            .then(resp => resp.json())
            .then(resp => setDivisions(resp))
        // isCarrierLoading(false);
    }
    const handleDChange = async (e) => {
        debugger;
        var value = e.target.value;
        if (filterKey == 'Freight Bill/Package Number' || filterKey == 'Transportation Provider Account Number') {

            let newfield = { name: filterKey, value: value };
            if (value == "") {
                value = -1;
            }
            if (filterKey == 'Freight Bill/Package Number') {
                setFbNum(value);
                if (selectedCust > 0) {
                    oncustom(selectedCust, selectedCarrier, selectedFromDate, selectedToDate, value, acctNo);
                }
            }
            else if (filterKey == 'Transportation Provider Account Number') {
                setAcctNo(value);
                if (selectedCust > 0) {
                    oncustom(selectedCust, selectedCarrier, selectedFromDate, selectedToDate, fbNum, value);
                }
            }
            upsert(inputFields, newfield);

        }
        else {
            debugger;
            var index = e.nativeEvent.target.selectedIndex;
            var text = e.nativeEvent.target[index].text;
            var key = e.nativeEvent.target[index].value;
            let newfield = { name: filterKey, value: text };
            // upsert(inputFields, newfield);
            var array = [...inputFields];
            switch (filterKey) {
                case 'Owner':
                    index = array.findIndex(_element => _element.name === 'Customer');
                    if (index !== -1) {
                        array.splice(index, 1);
                        setInputFields(array);
                    }
                    index = array.findIndex(_element => _element.name === 'Transportation Provider');
                    if (index !== -1) {
                        array.splice(index, 1);
                        setInputFields(array);
                    }

                    index = array.findIndex(_element => _element.name === 'Freight Bill/Package Number');
                    if (index !== -1) {
                        array.splice(index, 1);
                        setInputFields(array);
                    }

                    index = array.findIndex(_element => _element.name === 'Transportation Provider Account Number');
                    if (index !== -1) {
                        array.splice(index, 1);
                        setInputFields(array);
                    }

                    index = array.findIndex(_element => _element.name === 'Division');
                    if (index !== -1) {
                        array.splice(index, 1);
                        setInputFields(array);
                    }
                    if (isDateDropdownHidden === true) {
                        LoadCustomer(key);
                        LoadDivision(-1);
                        setSelectedCust(-1);
                        setSelectedDivision(1);
                        oncustom(-1, selectedPastNumOfWeek, selectedImmediatePastNumWeek, selectedPercentageDecrease, selectedPercentageIncrease, -1);
                    }
                    else {
                        LoadCustomer(key);
                        LoadCarrier(-1);
                        setSelectedOwner(key);
                        setSelectedCust(-1);
                        setSelectedCarr(0);
                        setFbNum("-1");
                        setAcctNo("-1");
                        oncustom(-1, 0, selectedFromDate, selectedToDate, -1, -1);
                    }
                    break;
                case 'Customer':
                    index = array.findIndex(_element => _element.name === 'Transportation Provider');
                    if (index !== -1) {
                        array.splice(index, 1);
                        setInputFields(array);
                    }

                    index = array.findIndex(_element => _element.name === 'Freight Bill/Package Number');
                    if (index !== -1) {
                        array.splice(index, 1);
                        setInputFields(array);
                    }

                    index = array.findIndex(_element => _element.name === 'Transportation Provider Account Number');
                    if (index !== -1) {
                        array.splice(index, 1);
                        setInputFields(array);
                    }

                    index = array.findIndex(_element => _element.name === 'Division');
                    if (index !== -1) {
                        array.splice(index, 1);
                        setInputFields(array);
                    }

                    if (isDateDropdownHidden === true) {
                        setSelectedCust(key);
                        setSelectedDivision(-1);
                        LoadDivision(key);
                        oncustom(key, selectedPastNumOfWeek, selectedImmediatePastNumWeek, selectedPercentageDecrease, selectedPercentageIncrease, -1);
                    }
                    else {
                        setSelectedCust(key);
                        setSelectedCarr(0);
                        setFbNum("-1");
                        setAcctNo("-1");
                        LoadCarrier(key);
                        oncustom(key, -1, selectedFromDate, selectedToDate, -1, -1);
                    }
                    break;
                case 'Division':
                    setSelectedDivision(key);
                    oncustom(selectedCust, selectedPastNumOfWeek, selectedImmediatePastNumWeek, selectedPercentageDecrease, selectedPercentageIncrease, key);
                    break;
                default:
                    setSelectedCarr(key);
                    setFbNum("-1");
                    setAcctNo("-1");
                    index = array.findIndex(_element => _element.name === 'Freight Bill/Package Number');
                    if (index !== -1) {
                        array.splice(index, 1);
                        setInputFields(array);
                    }

                    index = array.findIndex(_element => _element.name === 'Transportation Provider Account Number');
                    if (index !== -1) {
                        array.splice(index, 1);
                        setInputFields(array);
                    }
                    oncustom(selectedCust, key, selectedFromDate, selectedToDate, -1, -1);
                // code block
            }
            upsert(inputFields, newfield);
            setShow(false);

            if (filterKey == 'Owner') {

                // if (isDateDropdownHidden === true) {
                //     oncustom(selectedCust, selectedDivision);
                // }
                // else {
                //     oncustom(selectedCust, selectedCarrier, selectedFromDate, selectedToDate, fbNum, acctNo);
                // }
                // props.oncustom(key,text)
                // console.log(text)  

            }
            else if (filterKey == 'Customer') {
                // props.oncustom(key,text)
                // console.log(text)  
            }
            else if (filterKey == 'Division') {
            }
            else {
                // oncustom1(text);
            }
        }

    }
    const clearHeaderElement = (row) => {
        debugger;
        console.log('selct option1')
        var array = [...inputFields];
        var index = array.findIndex(_element => _element.name === row.name);
        if (index !== -1) {
            array.splice(index, 1);
            setInputFields(array);
            if (row.name === 'Owner') {
                index = array.findIndex(_element => _element.name === 'Customer');
                if (index !== -1) {
                    array.splice(index, 1);
                    setInputFields(array);
                }

                index = array.findIndex(_element => _element.name === 'Transportation Provider');
                if (index !== -1) {
                    array.splice(index, 1);
                    setInputFields(array);
                }

                index = array.findIndex(_element => _element.name === 'Freight Bill/Package Number');
                if (index !== -1) {
                    array.splice(index, 1);
                    setInputFields(array);
                }

                index = array.findIndex(_element => _element.name === 'Transportation Provider Account Number');
                if (index !== -1) {
                    array.splice(index, 1);
                    setInputFields(array);
                }

                index = array.findIndex(_element => _element.name === 'Division');
                if (index !== -1) {
                    array.splice(index, 1);
                    setInputFields(array);
                }

                if (isDateDropdownHidden === true) {
                    setSelectedCust(-1);
                    setSelectedDivision(1);
                    LoadCustomer(-1);
                    LoadDivision(-1);
                    oncustom(-1, selectedPastNumOfWeek, selectedImmediatePastNumWeek, selectedPercentageDecrease, selectedPercentageIncrease, -1);
                }
                else {
                    setSelectedCust(-1);
                    setSelectedCarr(0);
                    setFbNum("-1");
                    setAcctNo("-1");
                    LoadCustomer(-1);
                    LoadCarrier(-1);
                    oncustom(-1, 0, selectedFromDate, selectedToDate, fbNum, acctNo);
                }

            }

            if (row.name === 'Customer') {
                index = array.findIndex(_element => _element.name === 'Transportation Provider');
                if (index !== -1) {
                    array.splice(index, 1);
                    setInputFields(array);
                }

                index = array.findIndex(_element => _element.name === 'Freight Bill/Package Number');
                if (index !== -1) {
                    array.splice(index, 1);
                    setInputFields(array);
                }

                index = array.findIndex(_element => _element.name === 'Transportation Provider Account Number');
                if (index !== -1) {
                    array.splice(index, 1);
                    setInputFields(array);
                }

                index = array.findIndex(_element => _element.name === 'Division');
                if (index !== -1) {
                    array.splice(index, 1);
                    setInputFields(array);
                }

                if (isDateDropdownHidden === true) {
                    setSelectedCust(-1);
                    setSelectedDivision(-1);
                    LoadDivision(-1);
                    oncustom(-1, selectedPastNumOfWeek, selectedImmediatePastNumWeek, selectedPercentageDecrease, selectedPercentageIncrease, -1);
                }
                else {
                    setSelectedCust(-1);
                    setSelectedCarr(0);
                    setFbNum("-1");
                    setAcctNo("-1");
                    LoadCarrier(-1);
                    oncustom(-1, 0, selectedFromDate, selectedToDate, fbNum, acctNo);
                }

            }
            if (row.name == 'Transportation Provider') {
                setSelectedCarr(0);
                oncustom(selectedCust, 0, selectedFromDate, selectedToDate, fbNum, acctNo);
            }
            if (row.name == 'Freight Bill/Package Number') {
                setFbNum("-1");
                oncustom(selectedCust, selectedCarrier, selectedFromDate, selectedToDate, "-1", acctNo);
            }
            if (row.name == 'Transportation Provider Account Number') {
                setAcctNo("-1");
                oncustom(selectedCust, selectedCarrier, selectedFromDate, selectedToDate, fbNum, "-1");
            }
            if (row.name == 'Division') {
                setSelectedDivision(-1);
                oncustom(selectedCust, selectedPastNumOfWeek, selectedImmediatePastNumWeek, selectedPercentageDecrease, selectedPercentageIncrease, -1);
            }
        }
    }

    const setShowing = (e) => {
        setShow(!show);
    }

    // useEffect(() => {

    //     setShowing();

    // });

    const selectFromDate = (e) => {
        //debugger;
        console.log(e);
        setSelectedFromDate(e.target.value);
        console.log(selectedFromDate);
        oncustom(selectedCust, selectedCarrier, selectedFromDate, selectedToDate, fbNum, acctNo);
    };

    const handleFromDateSelect = (e) => {
        debugger;
        if (!e) {
            return;
        }

        var iYear = e.toLocaleDateString().split('/')[2]

        console.log(iYear);
        console.log(selectedCust);

        // if (selectedCust == 0) {
        //     document.getElementById("filter-error").innerHTML ='Customer is a Required Field, a selection must be made';
        //     return;
        // }

        if (iYear.length === 4) {

            var myFromDate = new Date(moment(e).format().substring(0, 10));
            if (myFromDate.toString() == 'Invalid Date') {
                document.getElementById("filter-error").innerHTML = 'Invalid Date'
                return;
            }

            var today = new Date();

            if (e > today) {
                // document.getElementById("error").innerHTML = "From Entry Date is greater than To Entry Date";
                document.getElementById("filter-error").innerHTML = "From Entry Date is greater than Current Date";
                return;
            }
            else if (e > toDate) {
                // document.getElementById("error").innerHTML = "From Entry Date is greater than To Entry Date";
                document.getElementById("filter-error").innerHTML = "From Entry Date is greater than To Entry Date";
                return;
            }
            else {
                document.getElementById("filter-error").innerHTML = "";
            }

            setFromDate(e);
            setSelectedFromDate(moment(e).format().substring(0, 10));
            // console.log(selectedFromDate);
            if (isAddFilterHidden) {
                oncustom(selectedOwner, selectedCust, selectedCarrier, moment(e).format().substring(0, 10), selectedToDate, fbNum, acctNo);
            }
            else {
                oncustom(selectedCust, selectedCarrier, moment(e).format().substring(0, 10), selectedToDate, fbNum, acctNo);
            }

            // if (selectedCust > 0) {
            //     oncustom(selectedCust, selectedCarrier, moment(e).format().substring(0, 10), selectedToDate, fbNum, acctNo);
        }
        // }

    };

    const handleToDateSelect = (e) => {
        debugger;

        if (!e) {
            return;
        }

        var myToDate = new Date(moment(e).format().substring(0, 10));
        if (myToDate.toString() == 'Invalid Date') {
            document.getElementById("filter-error").innerHTML = 'Invalid Date'
            return;
        }

        var today = new Date();
        if (e > today) {
            // document.getElementById("error").innerHTML = "From Entry Date is greater than To Entry Date";
            document.getElementById("filter-error").innerHTML = "To Entry Date is greater than Current Date";
            return;
        }
        if (e < fromDate) {
            // document.getElementById("error").innerHTML = "From Entry Date is greater than To Entry Date";
            document.getElementById("filter-error").innerHTML = "To Entry Date is lesser than From Entry Date";
            return;
        }
        else {
            document.getElementById("filter-error").innerHTML = "";
        }

        setToDate(e);
        setSelectedToDate(moment(e).format().substring(0, 10));
        if (isAddFilterHidden) {
            oncustom(selectedOwner, selectedCust, selectedCarrier, selectedFromDate, moment(e).format().substring(0, 10), fbNum, acctNo);
        }
        else {
            oncustom(selectedCust, selectedCarrier, selectedFromDate, moment(e).format().substring(0, 10), fbNum, acctNo);
        }

        // console.log(selectedFromDate);
        // if (selectedCust > 0) {
        //     oncustom(selectedCust, selectedCarrier, selectedFromDate, moment(e).format().substring(0, 10), fbNum, acctNo);
        // }
    };

    const selectToDate = (e) => {
        setSelectedToDate(e.target.value)
        oncustom(selectedCust, selectedCarrier, selectedFromDate, selectedToDate, fbNum, acctNo);

    };

    const onCustomerSelect = (e) => {
        // debugger;
        var custkey = e;
        setSelectedCust(custkey);
        oncustom(selectedOwner, custkey, selectedCarrier, selectedFromDate, selectedToDate, fbNum, acctNo);

        // LoadCarrier(e);
        // props.onCustomerChange(custkey);

    };

    useEffect(() => {
        if (isAddFilterHidden == true) {
            LoadOwner();
        }
    }, [])


    return (
        <>

            <div className='top-filter-container mb-1 border rounded-1 p-1 d-flex align-items-center flex-wrap'>
                <div hidden={isDateDropdownHidden}>
                    <Dropdown>
                        <Dropdown.Toggle variant="default" id="dropdown-basic2">
                            <button className='btn p-0'>
                                <div className='filter-result bg-white p-1 border rounded-1 me-1 d-flex align-items-center'>
                                    <span className=''>Entry Date : {moment(selectedFromDate).format('L')} - {moment(selectedToDate).format('L')} </span>
                                    {/* <a href='#' className='me-1'><i className="ic fa fa-close"></i></a> */}
                                </div>
                            </button>
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                            <div className='filter-item  bg-white p-1'>
                                <div id="filter-error" className="text-danger"></div>
                                <div className='d-flex'>
                                    <div className="form-field me-2">
                                        <label>From Entry Date</label>
                                        <div>
                                            {/* <input type="date" className="form-control form-control-sm" defaultValue={defaultFromValue} onChange={selectFromDate} ></input> */}
                                            <DatePicker className="" value={fromDate} onChange={handleFromDateSelect} calendarIcon={<i className='fas fa-calendar-alt'></i>} format="MM/dd/yyyy" />
                                        </div>
                                    </div>
                                    <div className="form-field">
                                        <label>To Entry Date</label>
                                        <div>
                                            {/* <input type="date" className="form-control form-control-sm" defaultValue={defaultToValue} onChange={selectToDate}></input> */}
                                            <DatePicker className="" value={toDate} onChange={handleToDateSelect} calendarIcon={<i className='fas fa-calendar-alt'></i>} format="MM/dd/yyyy" />
                                        </div>
                                    </div>
                                    {/* <button className='close-filter'><i class="fas fa-times"></i></button> */}
                                </div>
                            </div>
                        </Dropdown.Menu>
                    </Dropdown>
                </div>
                <GridHeaderfilter populatedata={inputFields} cleardata={clearHeaderElement}></GridHeaderfilter>
                <Dropdown show={show}>
                    <Dropdown.Toggle variant="default" id="dropdown-basic">
                        <button className='btn btn-add-filter' onClick={setShowing} hidden={isAddFilterHidden}><img src={AddFilter}></img>Add Filter</button>
                    </Dropdown.Toggle>
                    {show
                        ? <Dropdown.Menu>
                            <div className='filter-item  bg-white p-1'>
                                <TopFilterData filterkey={setFilterKey} carrierData={carriers} customerData={customers} onChange={handleDChange} criData={criData} divisionData={divsions} />
                            </div>
                        </Dropdown.Menu>
                        :
                        null
                    }
                </Dropdown>
                {isAddFilterHidden
                    ?
                    <div className="p-2" style={{ width: '300px' }}>
                        <SelectSearch
                            width="300px"

                            id="ddnOwner"
                            name="ddnOwner"
                            // value={props.topFilterCustKey != '' ? props.topFilterCustKey : selectedCust}
                            value={selectedOwner}
                            options={owners}
                            onChange={onOwnerSelect}
                            search
                            filterOptions={fuzzySearch}
                        >
                        </SelectSearch>
                    </div>
                    :
                    null
                }
                {isAddFilterHidden
                    ?
                    < div className="p-2" style={{ width: '300px' }}>
                        <SelectSearch
                            width="300px"
                            id="ddnCustomer"
                            name="ddnCustomer"
                            // value={props.topFilterCustKey != '' ? props.topFilterCustKey : selectedCust}
                            value={selectedCust}
                            options={customers}
                            onChange={onCustomerSelect}
                            search
                            filterOptions={fuzzySearch}
                        >
                        </SelectSearch>
                    </div>
                    :
                    null
                }
                {customerLoading ? <Spinner className='spinner-border spinner-border-topfilter' animation="border" variant="primary" /> : customerLoading}


            </div>



        </>

    )
}
